import { SIGNED_IN, SIGNED_OUT } from '../types'

const initialState = {
  isLoggedIn: false,
  fullname: '',
  email: '',
  type: '',
}
const navigate = (state = initialState, action) => {
  switch (action.type) {
    case SIGNED_IN: {
      return { ...action.payload, isLoggedIn: true }
    }
    case SIGNED_OUT: {
      return {
        isLoggedIn: false,
        fullname: '',
        email: '',
        type: '',
      }
    }
    default:
      return state
  }
}

export default navigate
